<template>
  <div>
    <v-autocomplete
      @change="brandChanged($event)"
      v-model="brandSelection"
      :filter="searchFilter"
      :items="brands"
      no-data-text="Error fetching data, please refresh the page and try again"
      outlined
      dense
    >
      <template slot="selection" slot-scope="{ item }">
        {{ item.title }}
      </template>
      <template slot="item" slot-scope="{ item }">
        {{ item.title }}
      </template>
      <template slot="prepend">
        <div class="prepend-text">Brand</div>
      </template>
    </v-autocomplete>

    <v-autocomplete
      v-model="typeSelection"
      :filter="searchFilter"
      :items="types"
      :loading="modelsLoading"
      no-data-text="Please select a brand"
      outlined
      dense
    >
      <template slot="prepend">
        <div class="prepend-text">Club Type</div>
      </template>
    </v-autocomplete>

    <v-autocomplete
      v-model="modelSelection"
      :filter="searchFilter"
      :items="filtered_models"
      :loading="modelsLoading"
      return-object
      no-data-text="Please select a brand"
      @change="clubSelected"
      outlined
      dense
    >
      <template slot="selection" slot-scope="{ item }">
        {{ item.title }}
      </template>
      <template slot="item" slot-scope="{ item }">
        {{ item.title }}
      </template>
      <template slot="prepend">
        <div class="prepend-text">Model</div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { productsCollection } from "@/firebase";
export default {
  name: "ClubPicker",
  data() {
    return {
      brands: [],
      brandSelection: null,

      types: [],
      typeSelection: null,

      models: [],
      modelsLoading: false,
      modelSelection: null,
    };
  },
  created() {
    productsCollection
      .where("enabled", "==", true)
      .get()
      .then((snapshot) => {
        if (snapshot.empty) {
          console.log("No data to show");
        }
        snapshot.forEach((doc) => {
          this.brands.push({ id: doc.id, ...doc.data() });
        });
      });
  },
  methods: {
    clubSelected() {
      this.$emit('selection-changed', {...this.modelSelection, vendor: this.brandSelection.title});
      this.clearSelection();
    },
    brandChanged($event) {
      this.modelSelection = null;
      this.models = [];
      this.loadModels($event.id);
    },
    loadModels(brand_id) {
      this.modelsLoading = true;
      const config = this.$store.getters.getConfig;
      let query = productsCollection.doc(brand_id).collection("Models");
      if (config["Show Unpriced Clubs"] !== true) {
        // NEeds to change to new model (Trade In Value)
        // query = query.where("Trade-In Mid", "!=", "");
        query = query.where("Trade In Value", "!=", "");
      }
      //productsCollection.doc(brand_id).collection('Models').where('Trade-In Mid', '!=', '').get()
      query.get().then((snapshot) => {
        if (snapshot.empty) {
          console.log("No data to show");
        }
        snapshot.forEach((doc) => {
          const product = { id: doc.id, ...doc.data() };
          const filtered = {
            id: product.id,
            title: product.Name,
            // Need to change to new model
            price: parseFloat(product["Trade In Value"]),
            type: product.Type,
            image: product["Image Path"],
          };
          this.models.push(filtered);
        });
        const types = this.models.map((m) => {
          return {
            text: this.capitalize(m.type, "-"),
            value: m.type,
          };
        });
        this.types = [...new Set(types)];
        this.modelsLoading = false;
      });
    },
    searchFilter(item, queryText) {
      // Don't show null items
      if (item.title === null || item.title === undefined) {
        return false;
      }
      const tokens = queryText.split(" ");
      let result = true;
      tokens.forEach((token) => {
        result =
          result && item.title.toLowerCase().includes(token.toLowerCase());
      });
      return result;
    },
    capitalize(string, sep) {
      const arr = string.split(sep);
      const Arr = arr.map((s) => s.charAt(0).toUpperCase() + s.slice(1));
      return Arr.join(" ");
    },
    clearSelection() {
      this.brandSelection = null;
      this.types = [];
      this.typeSelection = null;

      this.models = [];
      this.modelSelection = null;
    },
  },
  computed: {
    // Filter models by club type
    filtered_models() {
      if (this.typeSelection === null) {
        return this.models;
      } else {
        return this.models.filter((m) => m.type === this.typeSelection);
      }
    },
  },
};
</script>

<style scoped>
.prepend-text {
  border: 1px;
  white-space: nowrap;
  overflow: hidden;
  width: 180px;
  text-align: right;
}
</style>
